import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateService } from '@ngx-translate/core';
import { SwiperOptions } from 'swiper/types';
import { DataService } from '../../services/data.service';
import { MenuService } from '../../menu/menu.service';
import { findItemById } from '../../menu/menu.utils';
import { ModifierComponent } from '../modifier/modifier.component';
import { SwiperDirective } from '../directives/swiper.directive';
import { Promotion } from '../../models/cart.model';
import { ItemStatus } from '../../shared/enums';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrl: './promotion.component.scss',
  imports: [
    SwiperDirective,
    LazyLoadImageModule
  ],
  encapsulation: ViewEncapsulation.None,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PromotionComponent implements OnInit {

  private dataService = inject(DataService);
  private menuService = inject(MenuService);
  private router = inject(Router);
  private bottomSheet = inject(MatBottomSheet);
  private toastService = inject(ToastService);
  private translateService = inject(TranslateService);

  public promotions: Promotion[] = [];
  public config: SwiperOptions = {
    loop: true,
    autoplay: {
      disableOnInteraction: false
    },
    autoHeight: true,
    resizeObserver: true,
    spaceBetween: 30
  };

  public ngOnInit(): void {
    this.promotions = this.dataService.promotions();
  }

  public openPromotion(promo: Promotion): void {
    if (promo.menu_section?.id) {
      this.router.navigate(['/menu-list', promo.menu_section.id]);
      return;
    }

    if (promo.item?.id) {
      this.openItem(promo.item.id);
    }
  }

  private openItem(id: string): void {
    const item = findItemById(this.menuService.menu()?.sections ?? [], id);
    // A ReadOnly item still opens - the modifier sheet shows it view-only.
    if (!item) {
      return;
    }

    if (item.status === ItemStatus.Unavailable) {
      this.toastService.warning(this.translateService.instant('COMMON.ITEM_UNAVAILABLE'));
      return;
    }

    this.bottomSheet.open(ModifierComponent, {
      autoFocus: false,
      data: { item }
    });
  }

}
